module.exports = __webpack_public_path__ + "static/media/bgm.13e3ce4d.ogg";